export default __webpack_public_path__ + "static/media/Asset 16.2e7bc674.png";